export const baseUrl = 'https://app.consorziocer.it/api/'
